/* PETBLOT — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.pb-reveal:not(.pb-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pb-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-pb-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-pb-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        var mid = r.top + r.height / 2 - window.innerHeight / 2;
        // Desplazamiento limitado para que la foto nunca deje huecos
        var max = r.height * 0.04 * (k / 10);
        var y = Math.max(-max, Math.min(max, mid * -k / 100));
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(' + (1 + 0.1 * (k / 10)).toFixed(3) + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-pb-producto]').forEach(function (wrap) {
      if (wrap.dataset.pbListo) return;
      wrap.dataset.pbListo = '1';

      // Galería
      var principal = wrap.querySelector('[data-pb-principal]');
      wrap.querySelectorAll('[data-pb-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.src = btn.getAttribute('data-src');
          principal.alt = btn.getAttribute('data-alt') || '';
          wrap.querySelectorAll('[data-pb-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });

      // Cantidad
      var qty = wrap.querySelector('[data-pb-qty]');
      wrap.querySelectorAll('[data-pb-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-pb-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var dataEl = wrap.querySelector('[data-pb-variantes]');
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var boton = wrap.querySelector('[data-pb-boton]');
      var precio = wrap.querySelector('[data-pb-precio]');
      var antes = wrap.querySelector('[data-pb-antes]');
      var textos = { add: boton ? boton.getAttribute('data-txt-add') : '', agotado: boton ? boton.getAttribute('data-txt-agotado') : '' };
      if (dataEl) {
        var variantes = JSON.parse(dataEl.textContent);
        var selects = wrap.querySelectorAll('[data-pb-opcion]');
        var formato = wrap.getAttribute('data-money') || '${{amount}}';
        var dinero = function (c) {
          var n = (c / 100).toFixed(2);
          return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
        };
        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
            var v = variantes.find(function (vv) { return vv.options.every(function (o, i) { return o === elegidas[i]; }); });
            if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textos.agotado; } return; }
            if (idInput) idInput.value = v.id;
            if (precio) precio.textContent = dinero(v.price);
            if (antes) {
              if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = dinero(v.compare_at_price); antes.hidden = false; }
              else antes.hidden = true;
            }
            if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? textos.add : textos.agotado; }
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
          });
        });
      }

      // Añadir al carrito sin salir de la página (con respaldo al envío normal)
      if (form && window.fetch) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var err = wrap.querySelector('[data-pb-error]');
          if (err) err.textContent = '';
          if (boton) boton.setAttribute('aria-busy', 'true');
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) { if (err) err.textContent = res.j.description || res.j.message || 'No se pudo añadir.'; return; }
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
        });
      }
    });
  }

  // Datos de entrega del carrito: copia un resumen legible en la nota del pedido
  // y guarda los datos en el carrito para que no se pierdan al recargar.
  function initDatos() {
    var caja = document.querySelector('[data-pb-datos]');
    var form = document.getElementById('cart');
    if (!caja || !form) return;
    var campos = caja.querySelectorAll('[data-pb-dato]');
    var nota = caja.querySelector('[data-pb-nota]');

    function resumen() {
      var lineas = ['DATOS DE ENTREGA'];
      campos.forEach(function (c) { lineas.push(c.getAttribute('data-pb-dato') + ': ' + (c.value || '').trim()); });
      var chk = caja.querySelector('input[type="checkbox"]');
      lineas.push('Compromiso de recibir y pagar: ' + (chk && chk.checked ? 'Sí' : 'No'));
      return lineas.join('\n');
    }

    var t;
    function guardar() {
      clearTimeout(t);
      t = setTimeout(function () {
        var attrs = {};
        caja.querySelectorAll('[name^="attributes["]').forEach(function (c) {
          var k = c.name.slice(11, -1);
          attrs[k] = c.type === 'checkbox' ? (c.checked ? c.value : '') : c.value;
        });
        if (nota) nota.value = resumen();
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs, note: nota ? nota.value : undefined })
        }).catch(function () {});
      }, 600);
    }

    caja.addEventListener('input', function (e) { if (e.target.classList) e.target.classList.remove('pb-error'); guardar(); });
    caja.addEventListener('change', guardar);
    caja.querySelectorAll('input, select').forEach(function (c) {
      c.addEventListener('invalid', function () {
        c.classList.add('pb-error');
        caja.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    form.addEventListener('submit', function () { if (nota) nota.value = resumen(); });
  }

  // Botones "Pedir ahora" en la página de producto: abren el formulario contra entrega (Releasit)
  function initIrFormulario() {
    document.querySelectorAll('[data-pb-ir-formulario]').forEach(function (a) {
      if (a.dataset.pbListo) return;
      a.dataset.pbListo = '1';
      a.addEventListener('click', function (e) {
        var btn = Array.prototype.find.call(document.querySelectorAll('button'), function (b) {
          return /contra entrega/i.test(b.innerText || '') && b.offsetParent !== null && !b.closest('[data-pb-ir-formulario]');
        });
        if (btn) { e.preventDefault(); btn.click(); }
      });
    });
  }

  function initAll(root) { initReveals(root); initProducto(root); initDatos(); initIrFormulario(); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
